import { PlusCircleIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { GenericTable } from '@/modules/common';

import { useLacesTab } from './hooks/use-laces-tab';

export function LacesTab() {
  const { columns, fields, onAdd } = useLacesTab();

  return (
    <div>
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Laces Colors</h3>
        <Button
          data-testid="add-lace-button"
          onClick={onAdd}
          startIcon={<PlusCircleIcon size={16} />}
        >
          Add Laces Color
        </Button>
      </div>
      <GenericTable
        name="lacesColors"
        key="laces-table"
        columns={columns}
        data={fields}
        emptyCellClassName="h-20"
        tableCellClassName="py-1"
        tableRowClassName="hover:bg-transparent"
        disabledColumnsIdsToClick={['name', 'hex', 'quantity', 'actions']}
        emptyTitle="No laces colors yet"
        emptyDescription="Start adding laces colors."
        emptyButton={
          <Button
            data-testid="add-lace-button"
            onClick={onAdd}
            startIcon={<PlusCircleIcon size={16} />}
          >
            Add Laces Color
          </Button>
        }
      >
        <p className="text-zinc-400 text-sm">
          All laces colors: {fields.length}
        </p>
      </GenericTable>
    </div>
  );
}
